import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { Typography } from '@material-ui/core';

import { convertToEstablishmentName, convertToReal } from 'helpers/converters';

let header = [];

const singleEstablishmentHeader = [
  { title: 'Data' },
  { title: 'Categoria' },
  { title: 'Descrição' },
  { title: 'Valor' },
  { title: 'Meio de Pagamento' }
];

const allEstablishmentsHeader = [
  { title: 'Estabelecimento' },
  { title: 'Data' },
  { title: 'Categoria' },
  { title: 'Descrição' },
  { title: 'Valor' },
  { title: 'Meio de Pagamento' }
];

const TransactionsExport = React.forwardRef((props, ref) => {
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { establishments } = useSelector(state => state.login);
  const { startDate, endDate } = useSelector(state => state.dateFilter);
  const { selects, noEstablishmentFilters } = useSelector(state => state.filters);

  const establishmentName = convertToEstablishmentName(establishmentId, establishments) || 'Todos os estabelecimentos';

  if(!!establishmentId) {
    header = singleEstablishmentHeader;
  }

  if(!establishmentId) {
    header = allEstablishmentsHeader;
  }

  const categories = selects
    ?.find(filter => filter?.id == 'category')
    ?.options;

  const paymentMethods = selects
    ?.find(filter => filter?.id == 'paymentMethod')
    ?.options;

  const getCategoryName = categoryId => {
    if(!establishmentId) {
      return noEstablishmentFilters?.categories?.find(category => +category.categoryId == +categoryId)?.categoryName || '-';
    }

    return categories?.find(category => +category?.value == +categoryId)?.label || '';
  }

  const getPaymentMethodName = paymentMethodId => {
    if(!establishmentId) {
      return noEstablishmentFilters?.paymentMethods?.find(paymentMethod => +paymentMethod.establishmentPaymentMethodId == +paymentMethodId)?.paymentMethodName || '-';
    }

    return paymentMethods?.find(paymentMethod => +paymentMethod?.value == +paymentMethodId)?.label || '';
  }

  const formattedData = props?.data?.content?.length > 0 && props?.data?.content?.map(item => {
    return {
      establishmentId: item?.establishmentId,
      orderDateTime: moment(item?.orderDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss'),
      category: getCategoryName(item?.categoryId),
      description: item?.description || '',
      amount: convertToReal(item?.amount || ''),
      paymentMethod: getPaymentMethodName(item?.paymentMethodId)
    }
  });

  return(
    <div ref={ref} style={{ width: '100%', padding: 10 }}>
      <div>
        <Typography color='primary'>
          Transações
        </Typography>
      </div>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography color='primary'>
          {establishmentName}
        </Typography>
        <Typography color='primary'>
          {moment(startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} - {moment(endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
        </Typography>
      </div>
      <div style={{ width: '100%', marginTop: 20 }}>
        <table style={{ width: '100%', tableLayout: 'fixed', border: '1px solid #000000', borderCollapse: 'collapse' }}>
          <tr style={{ width: '100%', borderBottom: 'thin solid' }}>
            {header.map(item => (
              <th style={{ borderRight: 'thin solid', textAlign: 'left', padding: 5 }}>
                {item.title}
              </th>
            ))}
          </tr>
          {formattedData?.length > 0 && formattedData?.map(item => {
            const establishmentName = convertToEstablishmentName(item?.establishmentId, establishments);

            return(
              <tr style={{ width: '100%', borderBottom: 'thin solid' }}>
                {!establishmentId && (
                  <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>
                    {item?.establishmentId}
                    <br />
                    {establishmentName?.length > 10 ? `${establishmentName?.slice(0, 10)}...` : establishmentName}
                  </td>
                )}
                <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.orderDateTime}</td>
                <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.category}</td>
                <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.description}</td>
                <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.amount}</td>
                <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.paymentMethod}</td>
              </tr>
            );
          })}
        </table>
      </div>
      <div style={{ backgroundColor: '#E2E2E2', padding: 10, border: '1px solid #000000', borderTop: 'none' }}>
        {(+props?.data?.total == 1) ? (
          <p style={{ color: '#505050', margin: 0 }}>
            Este relatório tem {props?.data?.total} item.
          </p>
        ) : (
          <p style={{ color: '#505050', margin: 0 }}>
            Este relatório tem {props?.data?.total} itens.
          </p>
        )}
      </div>
    </div>
  );
});

export default TransactionsExport;